import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginForm from "../views/LoginForm.vue";
import store from "../store/index.js";
import { redireccionInicio } from '../services/pedidosCliente';

Vue.use(VueRouter);

const routes = [
  {
    path: '/cliente/pedidos',
    name: 'PedidosClienteInicio',
    component: () => import('../views/clientes/PedidosClienteIndex.vue'),
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/LoginForm",
    name: "LoginForm",
    component: LoginForm,
  },
  {
    path: "/ForgotPassword",
    name: "ForgotPassword",
    component: () => import("../views/ForgotPassword.vue"),
  },
  {
    path: "/Registro",
    name: "RegisterForm",
    component: () => import("../views/RegisterForm.vue"),
  },
  {
    path: "/ResetPassword/:token/:email",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue"),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/pedido",
    name: "pedido",
    component: () => import('../views/pedidos/PedidoForm.vue')
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.name !== "LoginForm" &&
    to.name !== "ForgotPassword" &&
    to.name !== "RegisterForm" &&
    to.name !== "ResetPassword" &&
    !store.getters.isAuthenticated
  ) {
    return next({ name: "LoginForm" });
  }
  const destino = redireccionInicio(to, store.getters.getUser);
  if (store.getters.isAuthenticated && destino) {
    return next({ path: destino, replace: true });
  }
  next();
});

export default router
